/**
 * Indirection over `window.location.assign` so tests can `vi.mock` this module
 * to capture the URL without navigating the test iframe.
 */
export function navigateToSsoUrl(url: string): void {
  window.location.assign(url)
}
